import { Component, ElementRef, OnInit, viewChild } from '@angular/core';
import {
    MultiUserAppointment,
    MultiUserAppointmentRequestType,
    Pagination
} from '../../../store/appointment/multi-user-appointment.entity';
import { MultiUserAppointmentService } from '../../../providers/multi-user-appointment.service';
import { Observable } from 'rxjs';
import { AppointmentInfoType } from '../../appointment-info/appointment-info';
import { ProfileService } from '../../../../profile/providers/profile.service';
import { AsyncPipe } from '@angular/common';
import { MultiUserAppointmentInfoComponent } from '../../appointment-info/multi-user-appointment-info/multi-user-appointment-info.component';
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap/pagination';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-multi-user-history-tab',
    templateUrl: './multi-user-history-tab.component.html',
    styleUrls: [
        './multi-user-history-tab.component.scss',
        '../../appointment-overview/multi-user-appointment-overview/multi-user-appointment-overview.component.scss'
    ],
    imports: [MultiUserAppointmentInfoComponent, NgbPagination, AsyncPipe, TranslatePipe]
})
export class MultiUserHistoryTabComponent implements OnInit {
    public isInit$: Observable<boolean>;
    public isProfileInit$: Observable<boolean>;
    public historyAppointments$: Observable<MultiUserAppointment[]>;
    public HISTORY_APPOINTMENT_INFO_TYPE = AppointmentInfoType.HISTORY;
    public pagination$: Observable<Pagination>;
    readonly itemsRef = viewChild<ElementRef>('itemsRef');

    constructor(private appointmentService: MultiUserAppointmentService,
                private profileService: ProfileService) {
        // Observable assignments are safe in the constructor (no side effects)
        this.pagination$ = this.appointmentService.getPagination$();
        this.isInit$ = this.appointmentService.isInit();
        this.isProfileInit$ = this.profileService.isInit$();
        this.historyAppointments$ = this.appointmentService.getAllMultiUserAppointments$();
    }

    ngOnInit(): void {
        // Side-effecting call moved from constructor to avoid ExpressionChanged errors
        this.appointmentService.getAppointments(MultiUserAppointmentRequestType.HISTORY);
    }

    public onPageChange(pageNumber: number) {
        const position = this.itemsRef().nativeElement.offsetTop;
        this.appointmentService.getAppointments(
            MultiUserAppointmentRequestType.HISTORY,
            {pageNumber: pageNumber.toString()},
            position
        );
    }
}
